import { Container, Image, TextArea, Form, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import { useSelector, useDispatch } from "react-redux"
import { setLetterCapCallData, setLetterJsOfficer } from "../../redux/projectSlice"

// Sections of the "Technical requirements" annex, filled from the cap call technical requirements checklist
export const capCallTechnicalRequirementSections = [
    { key: 'capitalisationPotential', title: 'Capitalisation potential', match: /capitali[sz]ation potential/i },
    { key: 'expectedImpact', title: 'Expected impact', match: /expected impact/i },
    { key: 'partnershipCooperation', title: 'Quality of the partnership and cooperation', match: /partnership/i },
    { key: 'other', title: 'Other', match: /^other/i },
]

const CapCallDetailApproval = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const handleSelectChange = (e, data) => {
        dispatch(setLetterJsOfficer(data.value));
    }

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const legalRepresentative = lp.contacts.find(contact => contact.type === 'LegalRepresentative') ?? {}
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {legalRepresentative.title} {legalRepresentative.firstName} {legalRepresentative.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </Container>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const commission = projectState.capCallCommission
        const legalRepresentative = projectState.leadPartner.contacts.find(contact => contact.type === 'LegalRepresentative') ?? {}
        const title = project.title.find(title => title.language === 'EN')?.translation
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)

        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {legalRepresentative.title} {legalRepresentative.lastName},</p>
                <p>Congratulations! Your capitalisation initiative <span className="text-accent">{project.customIdentifier} – {title} ({project.acronym})</span> has been selected for funding by the NWE Monitoring Committee which took place on {commission.date}, in {commission.location}. We kindly ask you to inform your project partners.</p>
                <p>The Monitoring Committee has set technical requirements for you to fulfil (annexed to this letter) by <span className="text-accent">{commission.technicalRequirementsDeadline}, 12:00 CET (midday)</span> at the latest to be able to proceed with the finalisation of the approval process. In the coming days, a new version of your original project application form will appear in Jems under the ‘Modification’ heading. Most of the information from your capitalisation initiative will be transferred into your original application form automatically. You will then be able to address the technical requirements directly in Jems. Please contact your responsible JS officer <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print" onChange={handleSelectChange} /> {letter?.jsOfficer ? <span className="invisible-screen">{letter.jsOfficer[0]} <span className="text-accent">({letter.jsOfficer[1]})</span></span> : <span className="error-accent">Please select an Officer</span>}, as soon as possible to discuss the technical requirements and receive guidance about finalising the application form update process.</p>
                <p>Please note that your partnership agreement may need to be updated. This is compulsory if new partners have joined, since they need to also sign the agreement. Please make sure to upload the updated document under the ‘Contracts and Agreements’ Jems section by {commission.technicalRequirementsDeadline}.</p>
                <p>Finally, a <span className="text-accent">webinar for approved capitalisation initiatives</span> will take place on <span className="text-accent">{commission.webinarDate} online.</span> Please save the date as this webinar is mandatory for all project partners (excluding associated organisations).</p>
                <p>Kind regards,</p>
                <p className="espace-haut">David Grzegorzewski</p>
                <p>Programme Director</p>
            </Container>
        )
    }

    const renderLetterDetails = () => {
        const letter = projectState.letter
        return (
            <Container textAlign='justified' >
                <h3>Technical requirements</h3>
                {capCallTechnicalRequirementSections.map(section => (
                    <div key={section.key} className="prevent-page-break little-margin">
                        <h4 className={letter?.capCallData?.[section.key] ? undefined : 'invisible-print'}>{section.title}</h4>
                        <Form>
                            <TextArea className="notification-letter-text-area invisible-print" onChange={(e, data) => dispatch(setLetterCapCallData({ key: section.key, value: data.value }))} value={letter?.capCallData?.[section.key] ?? ''}></TextArea>
                        </Form>
                        <p className="line-break invisible-screen">{letter?.capCallData?.[section.key]}</p>
                    </div>
                ))}
            </Container>
        )
    }

    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                            <div className="page-break">
                                {renderLetterDetails()}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default CapCallDetailApproval;
